import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'quill/dist/quill.snow.css';
import ToastService from 'primevue/toastservice';
import '@/assets/styles/main.scss'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

const app = createApp(App)

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
})
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD38EB5lpIHsC1w-oIc-U0FmjDiAXsDwu0',
        language: 'pl',
        libraries: "places",
    },
})
app.use(store)
app.use(router)
app.use(ToastService)
app.use(ConfirmationService)

app.directive('tooltip', Tooltip);

app.mount('#app')
